import API from './api';

const TempleService = {
    // Get all temples with optional filters
    getTemples: async (params = {}) => {
        try {
            const response = await API.get('/temples', {
                params
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching temples:", error)
            throw error;
        }
    },

    // Get a single temple by ID
    getTempleById: async (id) => {
        try {
            const response = await API.get(`/temples/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching temple with ID ${id}:`, error)
            throw error;
        }
    },

    // Create a new temple
    createTemple: async (templeData) => {
        try {
            const response = await API.post('/temples', templeData);
            return response.data;
        } catch (error) {
            console.error("Error creating temple:", error)
            throw error;
        }
    },

    // Update an existing temple
    updateTemple: async (id, templeData) => {
        try {
            const response = await API.put(`/temples/${id}`, templeData);
            return response.data;
        } catch (error) {
            console.error(`Error updating temple with ID ${id}:`, error)
            throw error;
        }
    },

    // Delete a temple
    deleteTemple: async (id) => {
        try {
            const response = await API.delete(`/temples/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error deleting temple with ID ${id}:`, error)
            throw error;
        }
    },

    // Get featured temples
    getFeaturedTemples: async (limit = 6) => {
        try {
            const response = await API.get(`/temples/featured?limit=${limit}`)
            return response.data
        } catch (error) {
            console.error("Error fetching featured temples:", error)
            throw error
        }
    },

    // Get temples by category
    getTemplesByCategory: async (category, limit = 10) => {
        try {
            const response = await API.get(`/temples/category/${category}?limit=${limit}`)
            return response.data
        } catch (error) {
            console.error(`Error fetching temples in category ${category}:`, error)
            throw error
        }
    },

    // Get temples by state
    getTemplesByState: async (state, limit = 10) => {
        try {
            const response = await API.get(`/temples/state/${state}?limit=${limit}`)
            return response.data
        } catch (error) {
            console.error(`Error fetching temples in state ${state}:`, error)
            throw error
        }
    },

    // Search temples
    searchTemples: async (query) => {
        try {
            const response = await API.get(`/temples/search?q=${query}`)
            return response.data;
        } catch (error) {
            console.error("Error fetching featured temples:", error)
            throw error;
        }
    }, 

    // Upload temple image
    uploadTempleImage: async (file) => {
        try {
            const formData = new FormData()
            formData.append("image", file)

            const response = await API.post("/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })

            return response.data
        } catch (error) {
            console.error("Error uploading temple image:", error)
            throw error
        }
    },
}

export default TempleService;